import Navbar from '@/components/common/navbar';
import { SEO } from '@/components/common/seo';
import HeroSection from './components/hero-section';
import DeploymentExplorer from './components/deployment-explorer';
import SecuritySection from './components/security-section';
import ExistingDataSection from './components/existing-data-section';
import DeploymentFooter from './components/deployment-footer';

const Deployment = () => (
  <>
    <SEO canonical="/deployment" />
    <Navbar />
    <main className="min-h-screen bg-background font-sans text-foreground [--color-background:#FFFFFF] [--color-foreground:#0B1024] [--color-card:#FFFFFF] [--color-card-foreground:#0B1024] [--color-muted-foreground:#5A6484] [--color-border:#D3D9EA] [--color-secondary:#E8ECF7] pt-6 text-base leading-relaxed min-[601px]:text-[17px]">
      <div className="mx-auto max-w-[1180px] px-6">
        <HeroSection />
        <DeploymentExplorer />
        <SecuritySection />
        <ExistingDataSection />
        <DeploymentFooter />
      </div>
    </main>
  </>
);

export default Deployment;
